var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"resource_tree__wrapper"},[_c('div',[_c('el-tree',{ref:"resourceTree",attrs:{"props":_vm.props,"load":_vm.loadNode,"node-key":"resourceId","lazy":""},on:{"node-click":_vm.nodeClick},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var node = ref.node;
var data = ref.data;
return _c('div',{staticClass:"custom-tree-node"},[_c('i',{class:data.icon}),_c('span',{staticStyle:{"margin-left":"5px"}},[_vm._v(_vm._s(node.label))])])}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }